angular.module('env.i18n.appLocale', [])

    .run(function (authService, appLocale, toastr) {
        authService.events.on("login", function () {
            appLocale.setCurrentLanguageFromCurrentUser()
                .catch(function (err) {
                    toastr.error("Can't set system language to " + appLocale.getCurrentLanguage());
                });
        });

        authService.events.on('continueSessionAfterReload', function () {
            appLocale.setCurrentLanguageFromCurrentUser()
                .catch(function (err) {
                    toastr.error("Can't set system language to " + appLocale.getCurrentLanguage());
                });
        });

        authService.events.on('authenticationRequiredAfterReload', function () {
            appLocale.setGuestLanguage()
                .catch(function (err) {
                    toastr.error("Can't set system language to " + appLocale.getCurrentLanguage());
                });
        });

        authService.events.on('logout', function () {
            appLocale.setGuestLanguage()
                .catch(function (err) {
                    toastr.error("Can't set system language to " + appLocale.getCurrentLanguage());
                });
        });
    })

    .service('appLocale', function ($window, $q, $http, LoadingMixin, angularLocalization, kendoLocalization, uiLocalization, serverLocalization, LocaleName, usersRepository) {
        var _this = this;

        _.extend(_this, new LoadingMixin());

        /**
         * Current language
         * @type {string}
         */
        var currentLanguage;

        /**
         * Get locale codes, that is supported by server
         * @returns {!Promise} promise
         */
        _this.getLanguagesList = function () {
            return serverLocalization.getLanguagesList();
        };


        /**
         * Cache of translated language codes
         * @type {Array}
         */
        var translatedLanguageList;

        /**
         * Get translated language codes
         * @returns {!Promise} promise
         */
        _this.getTranslatedLanguageList = function () {
            var deferred = $q.defer();
            if (translatedLanguageList) {
                deferred.resolve(translatedLanguageList);
            } else {
                $http.get('translations/localeTranslations.json')
                    .then(function (resp) {
                        try {
                            translatedLanguageList = resp.data;
                            deferred.resolve(translatedLanguageList);
                        } catch (err) {
                            deferred.reject(err);
                        }
                    }, function (err) {
                        deferred.reject(err);
                    });
            }

            return deferred.promise;
        };

        /**
         * Set language for guests
         */
        _this.setGuestLanguage = function () {
            var browserLocale = _this.getBrowserLocale();

            var l = new LocaleName(browserLocale).toString();
            return uiLocalization.setCurrentLanguage(l);
        };

        _this.getBrowserLocale = function () {
            return $window.navigator.language ||
                $window.navigator.browserLanguage ||
                $window.navigator.systemLanguage ||
                $window.navigator.userLanguage ||
                "en";
        };

        /**
         * Set current language
         * @param {string} lang - code of language
         * @returns {!Promise} promise
         */
        _this.setCurrentLanguage = function (lang) {
            _this.loading.start();
            currentLanguage = new LocaleName(lang).toString();

            return $q.all(
                [
                    angularLocalization.setCurrentLanguage(currentLanguage),
                    kendoLocalization.setCurrentLanguage(currentLanguage),
                    uiLocalization.setCurrentLanguage(currentLanguage),
                    serverLocalization.setCurrentLanguage(currentLanguage)
                ]).then(
                function (result) {
                    _this.loading.finish();
                    return result;
                },
                function (err) {
                    _this.loading.drop();
                    return $q.reject(err);
                });
        };

        /**
         * Set language from current user language
         *
         * @returns {!Promise} promise
         */
        _this.setCurrentLanguageFromCurrentUser = function () {
            return usersRepository.getCurrentUser()
                .then(function (user) {
                    if (!user.$model.culture) {
                        //Set at least browser locale for the user as the default
                        //until it will be changed by the user on his profile view
                        user.$model.culture = _this.getBrowserLocale();
                    }
                    return _this.setCurrentLanguage(user.$model.culture);
                });
        };

        /**
         * Get current language
         * @returns {string|undefined} current language code
         */
        _this.getCurrentLanguage = function () {
            return currentLanguage;
        };

        return _this;
    })
;